export const defaultEnTranslations = {
  title: 'AI Advisor',
  embeddedTitle: 'How can I assist you?',
  embeddedSubTitle: '',
  inputPlaceholder: 'Type your question',
  sendMessageButton: 'Send Message',
  poweredBy: 'Powered by',
  privacyLink: 'Privacy',
  multiChoiceFindButton: 'Find it',
  failedMessage: 'Message not sent. Tap to retry',
  addToCartButton: 'Add to cart',
  checkItOut: 'Check it out',
  quantity: 'Quantity',
  widget: {
    title: '<strong>AI</strong> Advisor',
    initPopup: {
      HOME: '',
      DEFAULT: 'Hi, any questions?',
      COLLECTION: '',
      PRODUCT: '',
    },
    hoverPopup: {
      HOME: '',
      DEFAULT: '',
      COLLECTION: '',
      PRODUCT: '',
    },
    stuckPopup: 'Can I help you with anything?',
    viewedProductsPopup: 'Browsing? Need help?',
    crossSalePopup: 'Want a complimentary item?',
    returnBackPopup: 'Return',
  },
  errors: {
    default: "Apologies, I'm currently unavailable. Please try again later.",
    emptyChatId: 'Chat ID is empty',
    notInitialized: 'Chat is not initialized. Please try again.',
    connectionFailure: 'Connection failure. Please try again.',
    noConnection: 'Unable to connect. Please check your internet connection and try again.',
    messageTooLong: 'Message is too long. Please shorten it.',
    messageNotDelivered: 'Message not delivered. Please try again.',
    addToCartFailure: 'Error adding the item to the cart. Please try again later.',
    variantNotAvailableForSale: 'This variant is not available for sale',
  },
  variants: {
    label: 'Choose {optionName}',
    emptySelectError: 'Oops, you didn’t select {optionsNames}',
    pleaseSelect: 'Select',
  },
  subscriptions: {
    mainLabel: 'Select Plan',
    oneTimePurchaseLabel: 'One time Purchase',
    subscribePurchaseLabel: 'Subscribe & Save {averageDiscount}%',
    deliverLabel: 'Deliver every',
  },

  // Deprecated

  widgetTitle: '',
  widgetTooltip: '',
};

type PopupText =
  | string
  | {
      HOME: string;
      DEFAULT: string;
      COLLECTION: string;
      PRODUCT: string;
    };

export type TranslationsType = typeof defaultEnTranslations & {
  widget: Omit<typeof defaultEnTranslations.widget, 'initPopup' | 'hoverPopup'> & {
    initPopup: PopupText;
    hoverPopup: PopupText;
  };
  prompts?: Record<string, { prompt?: string; caption: string }>;
};

// French
export const defaultFrTranslations = {
  title: 'Conseiller IA',
  embeddedTitle: 'Comment puis-je vous aider ?',
  embeddedSubTitle: '',
  inputPlaceholder: 'Tapez votre question',
  sendMessageButton: 'Envoyer le message',
  poweredBy: 'Propulsé par',
  privacyLink: 'Confidentialité',
  multiChoiceFindButton: 'Trouver',
  failedMessage: 'Message non envoyé. Touchez pour réessayer',
  addToCartButton: 'Ajouter au panier',
  checkItOut: 'Regarde ça',
  quantity: 'Quantité',
  widget: {
    title: '<strong>AI</strong> Advisor',
    initPopup: {
      HOME: '',
      DEFAULT: 'Salut, des questions ?',
      COLLECTION: '',
      PRODUCT: '',
    },
    stuckPopup: 'Puis-je vous aider avec quelque chose ?',
    viewedProductsPopup: 'Vous naviguez ? Besoin d’aide ?',
    crossSalePopup: 'Voulez-vous un article complémentaire ?',
    returnBackPopup: 'Retour',
    hoverPopup: {
      HOME: '',
      DEFAULT: '',
      COLLECTION: '',
      PRODUCT: '',
    },
  },
  errors: {
    default: 'Désolé, je ne suis pas disponible pour le moment. Veuillez réessayer plus tard.',
    emptyChatId: 'L’ID de chat est vide',
    notInitialized: 'Le chat n’est pas initialisé. Veuillez réessayer.',
    connectionFailure: 'Échec de la connexion. Veuillez réessayer.',
    noConnection: 'Impossible de se connecter. Veuillez vérifier votre connexion internet et réessayer.',
    messageTooLong: 'Le message est trop long. Veuillez le raccourcir.',
    messageNotDelivered: 'Message non délivré. Veuillez réessayer.',
    addToCartFailure: 'Erreur lors de l’ajout de l’article au panier. Veuillez réessayer plus tard.',
    variantNotAvailableForSale: 'Ce variant n’est pas disponible à la vente.',
  },
  variants: {
    label: 'Choisissez {optionName}',
    emptySelectError: 'Oups, vous n’avez pas sélectionné {optionsNames}',
    pleaseSelect: 'Sélectionner',
  },
  subscriptions: {
    mainLabel: 'Sélectionner un plan',
    oneTimePurchaseLabel: 'Achat unique',
    subscribePurchaseLabel: 'S’abonner et économiser {averageDiscount}%',
    deliverLabel: 'Livrer tous les',
  },

  // Deprecated

  widgetTitle: '',
  widgetTooltip: '',
};

// German
export const defaultDeTranslations = {
  title: 'KI-Berater',
  embeddedTitle: 'Wie kann ich Ihnen helfen?',
  embeddedSubTitle: '',
  inputPlaceholder: 'Geben Sie Ihre Frage ein',
  sendMessageButton: 'Nachricht senden',
  poweredBy: 'Angetrieben von',
  privacyLink: 'Datenschutz',
  multiChoiceFindButton: 'Finden',
  failedMessage: 'Nachricht nicht gesendet. Tippen zum Wiederholen',
  addToCartButton: 'In den Warenkorb',
  checkItOut: 'Schau es dir an',
  quantity: 'Menge',
  widget: {
    title: '<strong>AI</strong> Advisor',
    stuckPopup: 'Kann ich Ihnen bei etwas helfen?',
    viewedProductsPopup: 'Stöbern? Brauchen Sie Hilfe?',
    crossSalePopup: 'Möchten Sie einen kostenlosen Artikel?',
    returnBackPopup: 'Zurück',
    initPopup: {
      HOME: '',
      DEFAULT: 'Hallo, Fragen?',
      COLLECTION: '',
      PRODUCT: '',
    },
    hoverPopup: {
      HOME: '',
      DEFAULT: '',
      COLLECTION: '',
      PRODUCT: '',
    },
  },
  errors: {
    default: 'Entschuldigung, ich bin derzeit nicht verfügbar. Bitte versuchen Sie es später erneut.',
    emptyChatId: 'Chat-ID ist leer',
    notInitialized: 'Chat ist nicht initialisiert. Bitte versuchen Sie es erneut.',
    connectionFailure: 'Verbindungsfehler. Bitte versuchen Sie es erneut.',
    noConnection: 'Keine Verbindung möglich. Bitte prüfen Sie Ihre Internetverbindung und versuchen Sie es erneut.',
    messageTooLong: 'Nachricht ist zu lang. Bitte kürzen Sie sie.',
    messageNotDelivered: 'Nachricht nicht zugestellt. Bitte versuchen Sie es erneut.',
    addToCartFailure: 'Fehler beim Hinzufügen des Artikels zum Warenkorb. Bitte versuchen Sie es später erneut.',
    variantNotAvailableForSale: 'Diese Variante ist nicht zum Verkauf verfügbar.',
  },
  variants: {
    label: 'Wähle {optionName}',
    emptySelectError: 'Ups, Sie haben {optionsNames} nicht ausgewählt',
    pleaseSelect: 'Auswählen',
  },
  subscriptions: {
    mainLabel: 'Plan auswählen',
    oneTimePurchaseLabel: 'Einmaliger Kauf',
    subscribePurchaseLabel: 'Abonnieren & {averageDiscount}% sparen',
    deliverLabel: 'Lieferung alle',
  },

  // Deprecated

  widgetTitle: '',
  widgetTooltip: '',
};

// Spanish
export const defaultEsTranslations = {
  title: 'Asesor de IA',
  embeddedTitle: '¿Cómo puedo ayudarle?',
  embeddedSubTitle: '',
  inputPlaceholder: 'Escribe tu pregunta',
  sendMessageButton: 'Enviar mensaje',
  poweredBy: 'Desarrollado por',
  privacyLink: 'Privacidad',
  multiChoiceFindButton: 'Encontrar',
  failedMessage: 'Mensaje no enviado. Toca para reintentar',
  addToCartButton: 'Agregar al carrito',
  checkItOut: 'Échale un vistazo',
  quantity: 'Cantidad',
  widget: {
    title: '<strong>AI</strong> Advisor',
    initPopup: {
      HOME: '',
      DEFAULT: 'Hola, ¿alguna pregunta?',
      COLLECTION: '',
      PRODUCT: '',
    },
    stuckPopup: '¿Puedo ayudarte con algo?',
    viewedProductsPopup: '¿Navegando? ¿Necesitas ayuda?',
    crossSalePopup: '¿Quieres un artículo complementario?',
    returnBackPopup: 'Volver',
    hoverPopup: {
      HOME: '',
      DEFAULT: '',
      COLLECTION: '',
      PRODUCT: '',
    },
  },
  errors: {
    default: 'Lo siento, actualmente no estoy disponible. Por favor, inténtalo más tarde.',
    emptyChatId: 'El ID del chat está vacío',
    notInitialized: 'El chat no está inicializado. Por favor, inténtalo de nuevo.',
    connectionFailure: 'Fallo en la conexión. Por favor, inténtalo de nuevo.',
    noConnection: 'No se puede conectar. Verifica tu conexión a internet e inténtalo de nuevo.',
    messageTooLong: 'El mensaje es demasiado largo. Por favor, acórtalo.',
    messageNotDelivered: 'Mensaje no entregado. Por favor, inténtalo de nuevo.',
    addToCartFailure: 'Error al añadir el artículo al carrito. Por favor, inténtalo más tarde.',
    variantNotAvailableForSale: 'Esta variante no está disponible para la venta.',
  },
  variants: {
    label: 'Elige {optionName}',
    emptySelectError: 'Ups, no seleccionaste {optionsNames}',
    pleaseSelect: 'Seleccionar',
  },
  subscriptions: {
    mainLabel: 'Seleccionar plan',
    oneTimePurchaseLabel: 'Compra única',
    subscribePurchaseLabel: 'Suscríbete y ahorra {averageDiscount}%',
    deliverLabel: 'Entregar cada',
  },

  // Deprecated

  widgetTitle: '',
  widgetTooltip: '',
};

// Hebrew
export const defaultHeTranslations = {
  title: 'יועץ AI',
  embeddedTitle: 'איך אני יכול לעזור לך?',
  embeddedSubTitle: '',
  inputPlaceholder: 'הקלידו כאן',
  sendMessageButton: 'שלח ',
  poweredBy: 'מופעל על-ידי',
  privacyLink: 'פרטיות',
  multiChoiceFindButton: 'מצא זאת',
  failedMessage: 'ההודעה לא נשלחה. הקישו כדי לנסות שוב',
  addToCartButton: 'הוסף לעגלה',
  checkItOut: 'למידע נוסף',
  quantity: 'כמות',
  widget: {
    title: '<strong>יועץ</strong> בינה מלאכותית',
    initPopup: {
      HOME: '',
      DEFAULT: 'היי, יש לך שאלות?',
      COLLECTION: '',
      PRODUCT: '',
    },
    stuckPopup: 'אפשר לעזור במשהו?',
    viewedProductsPopup: 'גולשים? צריכים עזרה?',
    crossSalePopup: 'רוצים פריט נוסף במתנה?',
    returnBackPopup: 'חזרה',
    hoverPopup: {
      HOME: '',
      DEFAULT: '',
      COLLECTION: '',
      PRODUCT: '',
    },
  },
  errors: {
    default: 'מצטער, אני לא זמין כרגע. אנא נסו שוב מאוחר יותר.',
    emptyChatId: 'מזהה הצ׳אט ריק',
    notInitialized: 'הצ׳אט לא מאותחל. אנא נסו שוב.',
    connectionFailure: 'כשל בחיבור. אנא נסו שוב.',
    noConnection: 'לא ניתן להתחבר. אנא בדקו את חיבור האינטרנט ונסו שוב.',
    messageTooLong: 'ההודעה ארוכה מדי. אנא קצרו אותה.',
    messageNotDelivered: 'ההודעה לא נמסרה. אנא נסו שוב.',
    addToCartFailure: 'שגיאה בהוספת הפריט לעגלה. אנא נסו שוב מאוחר יותר.',
    variantNotAvailableForSale: 'הגרסה הזו אינה זמינה למכירה.',
  },
  variants: {
    label: 'בחרו {optionName}',
    emptySelectError: 'אופס, לא בחרתם אופציה {optionsNames}',
    pleaseSelect: 'בחרו',
  },
  subscriptions: {
    mainLabel: 'בחרו תוכנית',
    oneTimePurchaseLabel: 'רכישה חד פעמית',
    subscribePurchaseLabel: 'הירשמו וחסכו {averageDiscount}%',
    deliverLabel: 'משלוח כל',
  },

  // Deprecated

  widgetTitle: '',
  widgetTooltip: '',
};

// Greek
export const defaultElTranslations = {
  title: 'Σύμβουλος AI',
  embeddedTitle: 'Πώς μπορώ να σας βοηθήσω;',
  embeddedSubTitle: '',
  inputPlaceholder: 'Πληκτρολογήστε την ερώτησή σας',
  sendMessageButton: 'Αποστολή μηνύματος',
  poweredBy: 'Λειτουργεί με',
  privacyLink: 'Απόρρητο',
  multiChoiceFindButton: 'Βρείτε το',
  failedMessage: 'Το μήνυμα δεν στάλθηκε. Πατήστε για επανάληψη',
  addToCartButton: 'Προσθήκη στο καλάθι',
  checkItOut: 'Δες το (Des to)',
  quantity: 'Ποσότητα',
  widget: {
    title: '<strong>AI</strong> Advisor',
    initPopup: {
      HOME: '',
      DEFAULT: 'Γεια, έχετε καμιά ερώτηση;',
      COLLECTION: '',
      PRODUCT: '',
    },
    stuckPopup: 'Μπορώ να σας βοηθήσω σε κάτι;',
    viewedProductsPopup: 'Περιηγείστε; Χρειάζεστε βοήθεια;',
    crossSalePopup: 'Θέλετε ένα συμπληρωματικό προϊόν;',
    returnBackPopup: 'Επιστροφή',
    hoverPopup: {
      HOME: '',
      DEFAULT: '',
      COLLECTION: '',
      PRODUCT: '',
    },
  },
  errors: {
    default: 'Ζητούμε συγγνώμη, προς το παρόν δεν είμαι διαθέσιμος. Παρακαλώ δοκιμάστε αργότερα.',
    emptyChatId: 'Το ID συζήτησης είναι κενό',
    notInitialized: 'Η συζήτηση δεν έχει ξεκινήσει. Παρακαλώ δοκιμάστε ξανά.',
    connectionFailure: 'Αποτυχία σύνδεσης. Παρακαλώ δοκιμάστε ξανά.',
    noConnection: 'Δεν είναι δυνατή η σύνδεση. Ελέγξτε τη σύνδεση στο διαδίκτυο και δοκιμάστε ξανά.',
    messageTooLong: 'Το μήνυμα είναι πολύ μεγάλο. Παρακαλώ συντομεύστε το.',
    messageNotDelivered: 'Το μήνυμα δεν παραδόθηκε. Παρακαλώ δοκιμάστε ξανά.',
    addToCartFailure: 'Σφάλμα κατά την προσθήκη του αντικειμένου στο καλάθι. Παρακαλώ δοκιμάστε αργότερα.',
    variantNotAvailableForSale: 'Esta variante no está disponible para la venta.',
  },
  variants: {
    label: 'Επιλέξτε {optionName}',
    emptySelectError: 'Ουπς, δεν επιλέξατε {optionsNames}',
    pleaseSelect: 'Επιλέξτε',
  },
  subscriptions: {
    mainLabel: 'Επιλέξτε πλάνο',
    oneTimePurchaseLabel: 'Εφάπαξ αγορά',
    subscribePurchaseLabel: 'Εγγραφείτε & εξοικονομήστε {averageDiscount}%',
    deliverLabel: 'Παράδοση κάθε',
  },

  // Deprecated

  widgetTitle: '',
  widgetTooltip: '',
};

// Portuguese (Brazil)
export const defaultPtBRTranslations = {
  title: 'Consultor de IA',
  embeddedTitle: 'Como posso te ajudar?',
  embeddedSubTitle: '',
  inputPlaceholder: 'Digite sua pergunta',
  sendMessageButton: 'Enviar mensagem',
  poweredBy: 'Desenvolvido por',
  privacyLink: 'Privacidade',
  multiChoiceFindButton: 'Encontrar',
  failedMessage: 'Mensagem não enviada. Toque para tentar novamente',
  addToCartButton: 'Adicionar ao carrinho',
  checkItOut: 'Confere isso',
  quantity: 'Quantidade',
  widget: {
    title: '<strong>AI</strong> Advisor',
    initPopup: {
      HOME: '',
      DEFAULT: 'Oi, alguma dúvida?',
      COLLECTION: '',
      PRODUCT: '',
    },
    stuckPopup: 'Posso te ajudar com algo?',
    viewedProductsPopup: 'Navegando? Precisa de ajuda?',
    crossSalePopup: 'Quer um item complementar?',
    returnBackPopup: 'Voltar',
    hoverPopup: {
      HOME: '',
      DEFAULT: '',
      COLLECTION: '',
      PRODUCT: '',
    },
  },
  errors: {
    default: 'Desculpe, atualmente não estou disponível. Por favor, tente novamente mais tarde.',
    emptyChatId: 'ID do chat está vazio',
    notInitialized: 'Chat não inicializado. Por favor, tente novamente.',
    connectionFailure: 'Falha de conexão. Por favor, tente novamente.',
    noConnection: 'Não foi possível conectar. Verifique sua conexão com a internet e tente novamente.',
    messageTooLong: 'A mensagem é muito longa. Por favor, encurte-a.',
    messageNotDelivered: 'Mensagem não entregue. Por favor, tente novamente.',
    addToCartFailure: 'Erro ao adicionar o item ao carrinho. Por favor, tente novamente mais tarde.',
    variantNotAvailableForSale: 'Esta variante não está disponível para venda',
  },
  variants: {
    label: 'Escolha {optionName}',
    emptySelectError: 'Ops, você não selecionou {optionsNames}',
    pleaseSelect: 'Selecionar',
  },
  subscriptions: {
    mainLabel: 'Selecionar plano',
    oneTimePurchaseLabel: 'Compra avulsa',
    subscribePurchaseLabel: 'Assine e economize {averageDiscount}%',
    deliverLabel: 'Entregar a cada',
  },

  // Deprecated

  widgetTitle: '',
  widgetTooltip: '',
};

// Portuguese (Portugal)
export const defaultPtTranslations = {
  title: 'Assistente IA',
  embeddedTitle: 'Como posso ajudá-lo(a)?',
  embeddedSubTitle: '',
  inputPlaceholder: 'Escreva a sua pergunta',
  sendMessageButton: 'Enviar mensagem',
  poweredBy: 'Desenvolvido por',
  privacyLink: 'Privacidade',
  multiChoiceFindButton: 'Encontrar',
  failedMessage: 'Mensagem não enviada. Toque para tentar novamente',
  addToCartButton: 'Adicionar ao carrinho',
  checkItOut: 'Veja',
  quantity: 'Quantidade',
  widget: {
    title: '<strong>Assistente</strong> IA',
    initPopup: {
      HOME: '',
      DEFAULT: 'Olá, alguma pergunta?',
      COLLECTION: '',
      PRODUCT: '',
    },
    hoverPopup: {
      HOME: '',
      DEFAULT: '',
      COLLECTION: '',
      PRODUCT: '',
    },
    stuckPopup: 'Posso ajudar em algo?',
    viewedProductsPopup: 'A ver produtos? Precisa de ajuda?',
    crossSalePopup: 'Quer um item complementar gratuito?',
    returnBackPopup: 'Fechar',
  },
  errors: {
    default: 'Desculpe, estou indisponível de momento. Por favor tente mais tarde.',
    emptyChatId: 'ID de chat vazio',
    notInitialized: 'Chat não foi inicializado. Por favor tente de novo.',
    connectionFailure: 'Falha na ligação. Por favor tente de novo.',
    noConnection: 'Não foi possível ligar. Verifique a sua ligação à internet e tente novamente.',
    messageTooLong: 'Mensagem demasiado longa. Por favor reduza o tamanho.',
    messageNotDelivered: 'Mensagem não entregue. Por favor tente novamente.',
    addToCartFailure: 'Erro ao adicionar o item ao carrinho. Por favor tente mais tarde.',
    variantNotAvailableForSale: 'Esta variante não está disponível para venda',
  },
  variants: {
    label: 'Escolher {optionName}',
    emptySelectError: 'Ops, não selecionou {optionsNames}',
    pleaseSelect: 'Selecionar',
  },
  subscriptions: {
    mainLabel: 'Selecionar plano',
    oneTimePurchaseLabel: 'Compra única',
    subscribePurchaseLabel: 'Subscreva e poupe {averageDiscount}%',
    deliverLabel: 'Entregar a cada',
  },

  // Deprecated
  widgetTitle: '',
  widgetTooltip: '',
};

// Dutch (Netherlands)
export const defaultNlTranslations = {
  title: 'AI-adviseur',
  embeddedTitle: 'Hvordan kan jeg hjælpe dig?',
  embeddedSubTitle: '',
  inputPlaceholder: 'Typ je vraag',
  sendMessageButton: 'Verstuur bericht',
  poweredBy: 'Mogelijk gemaakt door',
  privacyLink: 'Privacy',
  multiChoiceFindButton: 'Zoeken',
  failedMessage: 'Bericht niet verzonden. Tik om opnieuw te proberen',
  addToCartButton: 'Toevoegen aan winkelwagen',
  checkItOut: 'Bekijk het',
  quantity: 'Aantal',
  widget: {
    title: '<strong>AI</strong>-adviseur',
    initPopup: {
      HOME: '',
      DEFAULT: 'Hallo, vragen?',
      COLLECTION: '',
      PRODUCT: '',
    },
    hoverPopup: {
      HOME: '',
      DEFAULT: '',
      COLLECTION: '',
      PRODUCT: '',
    },
    stuckPopup: 'Kan ik je ergens mee helpen?',
    viewedProductsPopup: 'Aan het kijken? Hulp nodig?',
    crossSalePopup: 'Wil je een gratis extra artikel?',
    returnBackPopup: 'Popup sluiten',
  },
  errors: {
    default: 'Sorry, ik ben momenteel niet beschikbaar. Probeer het later opnieuw.',
    emptyChatId: 'Chat-ID is leeg',
    notInitialized: 'Chat is niet geïnitialiseerd. Probeer opnieuw.',
    connectionFailure: 'Verbindingsfout. Probeer opnieuw.',
    noConnection: 'Kan geen verbinding maken. Controleer je internetverbinding en probeer opnieuw.',
    messageTooLong: 'Bericht is te lang. Verkort het alstublieft.',
    messageNotDelivered: 'Bericht niet bezorgd. Probeer opnieuw.',
    addToCartFailure: 'Fout bij het toevoegen van het artikel aan de winkelwagen. Probeer later opnieuw.',
    variantNotAvailableForSale: 'Deze variant is niet beschikbaar voor verkoop',
  },
  variants: {
    label: 'Kies {optionName}',
    emptySelectError: 'Oeps, je hebt geen {optionsNames} geselecteerd',
    pleaseSelect: 'Selecteer',
  },
  subscriptions: {
    mainLabel: 'Selecteer plan',
    oneTimePurchaseLabel: 'Eenmalige aankoop',
    subscribePurchaseLabel: 'Abonneer & bespaar {averageDiscount}%',
    deliverLabel: 'Bezorg elke',
  },

  // Deprecated
  widgetTitle: '',
  widgetTooltip: '',
};

// Romanian
export const defaultRoTranslations = {
  title: 'Consilier AI',
  embeddedTitle: 'Cum te pot ajuta?',
  embeddedSubTitle: '',
  inputPlaceholder: 'Scrie întrebarea ta',
  sendMessageButton: 'Trimite mesajul',
  poweredBy: 'Oferit de',
  privacyLink: 'Confidențialitate',
  multiChoiceFindButton: 'Găsește',
  failedMessage: 'Mesajul nu a fost trimis. Atinge pentru a reîncerca',
  addToCartButton: 'Adaugă în coș',
  checkItOut: 'Vezi',
  quantity: 'Cantitate',
  widget: {
    title: '<strong>AI</strong> Consilier',
    initPopup: {
      HOME: '',
      DEFAULT: 'Salut, ai vreo întrebare?',
      COLLECTION: '',
      PRODUCT: '',
    },
    hoverPopup: {
      HOME: '',
      DEFAULT: '',
      COLLECTION: '',
      PRODUCT: '',
    },
    stuckPopup: 'Te pot ajuta cu ceva?',
    viewedProductsPopup: 'Navighezi? Ai nevoie de ajutor?',
    crossSalePopup: 'Vrei un produs complementar?',
    returnBackPopup: 'Înapoi',
  },
  errors: {
    default: 'Ne pare rău, momentan nu sunt disponibil. Te rugăm să încerci din nou mai târziu.',
    emptyChatId: 'ID-ul conversației este gol',
    notInitialized: 'Conversația nu este inițializată. Te rugăm să încerci din nou.',
    connectionFailure: 'Eroare de conexiune. Te rugăm să încerci din nou.',
    noConnection: 'Nu se poate realiza conexiunea. Te rugăm să verifici conexiunea la internet și să încerci din nou.',
    messageTooLong: 'Mesajul este prea lung. Te rugăm să îl scurtezi.',
    messageNotDelivered: 'Mesajul nu a fost livrat. Te rugăm să încerci din nou.',
    addToCartFailure: 'Eroare la adăugarea produsului în coș. Te rugăm să încerci din nou mai târziu.',
    variantNotAvailableForSale: 'Această variantă nu este disponibilă pentru vânzare',
  },
  variants: {
    label: 'Alege {optionName}',
    emptySelectError: 'Oops, nu ai selectat {optionsNames}',
    pleaseSelect: 'Selectează',
  },
  subscriptions: {
    mainLabel: 'Selectează planul',
    oneTimePurchaseLabel: 'Achiziție unică',
    subscribePurchaseLabel: 'Abonează-te și economisește {averageDiscount}%',
    deliverLabel: 'Livrare la fiecare',
  },

  // Deprecated

  widgetTitle: '',
  widgetTooltip: '',
};

// Italian
export const defaultItTranslations = {
  title: 'Consulente AI',
  embeddedTitle: 'Come posso aiutarti?',
  embeddedSubTitle: '',
  inputPlaceholder: 'Scrivi la tua domanda',
  sendMessageButton: 'Invia messaggio',
  poweredBy: 'Offerto da',
  privacyLink: 'Privacy',
  multiChoiceFindButton: 'Trova',
  failedMessage: 'Messaggio non inviato. Tocca per riprovare',
  addToCartButton: 'Aggiungi al carrello',
  checkItOut: "Dai un'occhiata",
  quantity: 'Quantità',
  widget: {
    title: '<strong>AI</strong> Consulente',
    initPopup: {
      HOME: '',
      DEFAULT: 'Ciao, hai domande?',
      COLLECTION: '',
      PRODUCT: '',
    },
    hoverPopup: {
      HOME: '',
      DEFAULT: '',
      COLLECTION: '',
      PRODUCT: '',
    },
    stuckPopup: 'Posso aiutarti con qualcosa?',
    viewedProductsPopup: 'Stai navigando? Hai bisogno di aiuto?',
    crossSalePopup: 'Vuoi un articolo complementare?',
    returnBackPopup: 'Indietro',
  },
  errors: {
    default: 'Ci scusiamo, al momento non sono disponibile. Per favore riprova più tardi.',
    emptyChatId: "L'ID della chat è vuoto",
    notInitialized: 'La chat non è inizializzata. Per favore riprova.',
    connectionFailure: 'Errore di connessione. Per favore riprova.',
    noConnection: 'Impossibile connettersi. Controlla la tua connessione internet e riprova.',
    messageTooLong: 'Il messaggio è troppo lungo. Per favore abbrevialo.',
    messageNotDelivered: 'Messaggio non consegnato. Per favore riprova.',
    addToCartFailure: "Errore nell'aggiunta dell'articolo al carrello. Per favore riprova più tardi.",
    variantNotAvailableForSale: 'Questa variante non è disponibile per la vendita',
  },
  variants: {
    label: 'Scegli {optionName}',
    emptySelectError: 'Ops, non hai selezionato {optionsNames}',
    pleaseSelect: 'Seleziona',
  },
  subscriptions: {
    mainLabel: 'Seleziona piano',
    oneTimePurchaseLabel: 'Acquisto singolo',
    subscribePurchaseLabel: 'Abbonati e risparmia {averageDiscount}%',
    deliverLabel: 'Consegna ogni',
  },

  // Deprecated

  widgetTitle: '',
  widgetTooltip: '',
};

export const defaultTranslations = {
  en: defaultEnTranslations,
  fr: defaultFrTranslations,
  de: defaultDeTranslations,
  es: defaultEsTranslations,
  'he-IL': defaultHeTranslations,
  el: defaultElTranslations,
  it: defaultItTranslations,
  pt: defaultPtTranslations,
  nl: defaultNlTranslations,
  'pt-BR': defaultPtBRTranslations,
  ro: defaultRoTranslations,
} satisfies Record<string, TranslationsType>;
